/**
 * Class representing the response from the [Content Rendering Service](https://docs.amplience.net/integration/contentrenderingservice.html?h=rendering%20service).
 * Rendered content is the output of converting the JSON body of a content item using a template.
 */
export class RenderedContentItem {
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUmVuZGVyZWRDb250ZW50SXRlbS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvcmVuZGVyaW5nL21vZGVsL1JlbmRlcmVkQ29udGVudEl0ZW0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBR0E7OztHQUdHO0FBQ0gsTUFBTSxPQUFPLG1CQUFtQjtDQWtCL0IifQ==